import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = "https://taifurportfolioserver.onrender.com";
// const baseUrl = "http://localhost:4000";

const initialState = {
  isLoding: false,
  portfolio: [],
  responseStatus: "",
  responseMessage: "",
};

export const getPortfolio = createAsyncThunk(
  "portfilio/getPortfolio",
  async () => {
    try {
      const res = await axios.get(`${baseUrl}/api/portfolio`);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getSinglePortfolio = createAsyncThunk(
  "portfilio/getSinglePortfolio",
  async (id) => {
    try {
      const res = await axios.get(`${baseUrl}/api/portfolio/${id}`);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const createPortfolio = createAsyncThunk(
  "portfolio/createPortfolio",
  async (portfolio) => {
    try {
      const res = await axios.post(`${baseUrl}/api/portfolio`, portfolio);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updatePortfolio = createAsyncThunk(
  "portfolio/updatePortfolio",
  async (portData) => {
    try {
      const res = await axios.patch(
        `${baseUrl}/api/portfolio/${portData.id}`,
        portData
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deletePortfolio = createAsyncThunk(
  "portfolio/deletePortfolio",
  async (id) => {
    await axios.delete(`${baseUrl}/api/portfolio/${id}`);
    return id;
  }
);

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState: initialState,
  extraReducers: (build) => {
    build.addCase(getPortfolio.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(getPortfolio.fulfilled, (state, action) => {
      state.isLoding = false;
      state.portfolio = action.payload;
      state.responseMessage = "Portfolio get successfully";
      state.responseStatus = "success";
    });
    build.addCase(getPortfolio.rejected, (state, action) => {
      state.isLoding = false;
      state.portfolio = [];
      state.responseMessage = action.error.message;
      state.responseStatus = "rejected";
    });
    build.addCase(getSinglePortfolio.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(getSinglePortfolio.fulfilled, (state, action) => {
      state.isLoding = false;
      state.portfolio = action.payload;
      state.responseMessage = "Portfolio details get successfully";
      state.responseStatus = "success";
    });
    build.addCase(getSinglePortfolio.rejected, (state, action) => {
      state.isLoding = false;
      state.portfolio = [];
      state.responseMessage = action.error.message;
      state.responseStatus = "rejected";
    });
    build.addCase(createPortfolio.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(createPortfolio.fulfilled, (state, action) => {
      state.portfolio = action.payload;
      state.isLoding = false;
      state.responseMessage = "Portfolio create successfully";
      state.responseStatus = "success";
    });
    build.addCase(createPortfolio.rejected, (state, action) => {
      state.isLoding = false;
      state.portfolio = [];
      state.responseMessage = action.error.message;
      state.responseStatus = "rejected";
    });
    build.addCase(updatePortfolio.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(updatePortfolio.fulfilled, (state, action) => {
      const portfolio = state.portfolio.filter((port) =>
        port._id === action.payload.portfolioData.id ? action.payload : state
      );
      state.portfolio = portfolio;
      state.isLoding = false;
      state.responseMessage = "Portfolio Update successfully";
      state.responseStatus = "success";
    });
    build.addCase(updatePortfolio.rejected, (state, action) => {
      state.isLoding = false;
      state.portfolio = [];
      state.responseMessage = action.error.message;
      state.responseStatus = "rejected";
    });
    build.addCase(deletePortfolio.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(deletePortfolio.fulfilled, (state, action) => {
      state.portfolio = action.payload;
      state.isLoding = false;
      state.responseMessage = "Portfolio delete successfully";
      state.responseStatus = "success";
    });
    build.addCase(deletePortfolio.rejected, (state, action) => {
      state.isLoding = false;
      state.portfolio = [];
      state.responseMessage = action.error.message;
      state.responseStatus = "rejected";
    });
  },
});

export default portfolioSlice.reducer;
